// extracted by mini-css-extract-plugin
export default {"wrapper":"personInfo_wrapper__V+aF-","info":"personInfo_info__7dhkO","buttonSet":"personInfo_buttonSet__2RyQz"};